import React from 'react'
import {Link} from "react-router-dom";

const Mitral = () => {
    return (
        <>
            {/* aroctic section container start */}
            <div className="lg:flex">

                {/* main content */}
                <div className="px-6 lg:px-0 flex-grow flex flex-wrap lg:flex-nowrap items-center lg:items-stretch bg-blue-primary ">
                    {/* name */}
                    <div className="order-2 lg:order-2 w-full md:w-1/4 flex items-center justify-center lg:justify-start flex-shrink-0">
                        <div className="hidden lg:block flex-shrink-0 w-10 h-full bg-red-primary"></div>
                        <div className="pt-2 pb-6 md:pb-12 lg:pt-0 lg:pb-0 lg:px-6 xl:p-12">
                            <h2 className="font-extrabold uppercase text-3xl xl:text-4xl text-white md:mb-6">Mitral</h2>
                            <Link
                                to="/devices/mitral"
                                className="transition hover:bg-white hover:text-blue-primary hidden md:block text-center focus:outline-none text-xs 2xl:text-sm uppercase border-1 border-gray-light py-1 px-2 xl:py-2 xl:px-4 text-white font-light"
                            >
                                Discover more
                            </Link>
                        </div>
                    </div>

                    {/* paragraph */}
                    <div className="text-center order-3 lg:order-3 md:pr-12 lg:py-12 w-full md:w-3/4 lg:w-2/4 flex-shrink-0 h-full block md:flex items-center">
                        <p className="text-white font-light mb-6 text-sm xl:text-base 2xl:text-lg leading-relaxed text-center md:text-justify">
                        CORCYM offers a broad portfolio of mitral repair and replacement options, including
rings to reshape mitral repair and valves offering tailored options for replacement
                        </p>
                        <Link
                                to="/devices/mitral"
                                className="transition hover:bg-white hover:text-blue-primary mb-8 inline-block md:hidden text-center focus:outline-none text-xs 2xl:text-sm uppercase border-1 border-gray-light py-1 px-2 xl:py-2 xl:px-4 text-white font-light"
                            >
                                Discover more
                        </Link>
                    </div>
                    
                    {/* image */}
                    <div className="order-1 lg:order-3 w-full lg:w-1/4 flex justify-center lg:justify-between items-center">
                        <img src="/images/products/memo4d-1.png" className="devices-product-image flex-shrink pt-12" draggable={false}/>
                        {/* <div className="hidden lg:block flex-shrink-0 w-10 h-full bg-white"></div> */}
                    </div>
                </div>
                {/* main content */}

            </div>
            {/* aroctic section container end */}
        </>
    )
}

export default Mitral
